import React from 'react';

/**
 * Czech wording for the {@link RefreshProductListAction} tooltip/modal, used by the CZ Max Price
 * and CZ Reimbursement modules.
 *
 * @returns {JSX.Element} The Czech description text.
 */
export function CzechRefreshProductListDescription() {
	return (
		<>
			Kliknutím na toto tlačítko automaticky aktualizujete ceny, validity a ostatní detaily produktů na základě
			nastavení modulu. To také nevratně přepíše nastavení pole <strong>Use for calc.</strong>
		</>
	);
}
